import React from "react";

import { PricingDetailsModal } from "../../ExpertHelp/Pricing.jsx";
import EmployerDashboardSidebar from "./EmployerDashboardSidebar.jsx";
import EmployerDashboardTopNav from "./EmployerDashboardTopNav.jsx";

function EmployerDashboardLayout({
	navItems,
	headingTitle,
	headingIcon,
	backgroundColor,
	showExpertDetails,
	children,
}) {
	const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
	const [screenHeight, setScreenHeight] = React.useState(window.innerHeight);
	const [showSideBar, setShowSideBar] = React.useState(false);
	const [showDetailsModal, setShowDetailsModal] = React.useState(false);

	React.useEffect(() => {
		const handleResize = () => {
			setScreenWidth(window.innerWidth);
			setScreenHeight(window.innerHeight);
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, [screenWidth, screenHeight]);

	return (
		<div
			className="bg-[#f7f8f8] p-3 gap-3"
			style={{ height: `${screenHeight}px`, ...(screenWidth > 768 && { display: "flex" }) }}
		>
			<EmployerDashboardSidebar
				navItems={navItems}
				screenWidth={screenWidth}
				screenHeight={screenHeight}
				showSideBar={showSideBar}
				setShowSideBar={setShowSideBar}
			/>
			<div
				className="flex flex-col bg-white shadow-md rounded-2xl flex-1"
				style={{
					height: `calc(${screenHeight}px - 24px)`,
					...(showExpertDetails && { marginRight: -12, marginLeft: -12 }),
				}}
			>
				{showExpertDetails && (
					<div className="bg-blue-700 w-full -mt-3">
						<div className="flex items-center justify-between px-4" style={{ minHeight: 56 }}>
							<p className="text-white">
								Boost Your resume with Expert help! Get guidance from a professional resume writer to increase your
								chances of landing a job.
							</p>
							<button
								className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm font-normal"
								onClick={() => {
									setShowDetailsModal(true);
								}}
							>
								Learn More
							</button>
						</div>
					</div>
				)}
				<EmployerDashboardTopNav
					screenWidth={screenWidth}
					headingIcon={headingIcon}
					headingTitle={headingTitle}
					setShowSideBar={setShowSideBar}
				/>
				<div
					className="w-full h-full overflow-y-auto"
					style={{
						...(backgroundColor && { backgroundColor: backgroundColor }),
						...(showExpertDetails && { paddingRight: 12, paddingLeft: 12 }),
					}}
				>
					{children}
				</div>
			</div>
			{showDetailsModal && <PricingDetailsModal setShowDetailsModal={setShowDetailsModal} />}
		</div>
	);
}

export default EmployerDashboardLayout;
